import { INewsForBanner } from './types';
import { AnyAction } from 'redux';
import { EnumNewsActionTypes } from './actions';

export interface INewsState {
  newsForBanner: INewsForBanner[];
  newsBannerShow: boolean;
}

const initialState = {
  newsForBanner: [],
  newsBannerShow: true,
};

export default function newsReducer(state: INewsState = initialState, action: AnyAction): INewsState {
  switch (action.type) {
    case EnumNewsActionTypes.SET_NEWS_FOR_BANNER:
      return {
        ...state,
        newsForBanner: action.payload,
      };

    case EnumNewsActionTypes.SET_NEWS_BANNER_SHOWN:
      return {
        ...state,
        newsBannerShow: action.payload,
      };

    default:
      return state;
  }
}
